<!--
  -  Copyright (c) Qwoach LLC 2022. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 26/12/2022
  -->

<template>
	<el-step
		ref="stepView"
		v-bind="$attrs"
		>
		<slot></slot>
	</el-step>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";

export default {
	name: "QwStep",
	extends: BaseComponent,
	inheritAttrs: false,

	mounted(){
		console.log("QwStep: mounted: this.$refs = ", this.$refs, ", this.$parent = ", this.$parent, ", this.$parent.$refs.stepsView = " + this.$parent.$refs.stepsView)
		this.$refs.stepView.$parent = this.$parent//.$refs.stepsView
	},

	// computed: {
	// 	steps() {
	// 		return this.$parent.steps
	// 	}
	// },
}
</script>

<style lang="scss">

</style>
